module.exports = __webpack_public_path__ + "static/media/photo2@2x.e227932c.jpg";